module.exports = __webpack_public_path__ + "static/images/smart-spot-graph.d634b4eff05e71cb1830d7318599555d.svg";